import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import DiceGame from './DiceGame'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DiceGame/>
  </React.StrictMode>
);



